import React, { useState, useRef, useEffect } from 'react';
import ReactSelect from 'react-select'
import clsx from 'clsx';

import { useOnClickOutside } from 'hooks';

import { Icon } from '../Icon/Icon';

import styles from './Select.module.scss';

export type SelectItem = {
  label?: string;
  name?: string;
  value: any;
  extraField?: string
};

export type SelectProps = {
  className?: string;
  placeholder?: string;
  defaultValue?: SelectItem;
  items: SelectItem[];
  hasError?: boolean;
  onSelect?: (item: SelectItem) => void;
};

const customStyles = {
  option: (provided: any, state: any) => {
    return {
      ...provided,
      // borderBottom: '1px dotted gray',
      color: state.data?.disabled ? 'gray' : state.isSelected ? 'white' : 'black',
      padding: 20,
      backgroundColor: state.isSelected ? '#3663ed' : provided.backgroundColor
    }
  },
  control: (provided: any, state: any) => {
    let result = {
      ...provided,
      height: 56,
      minHeight: 56,
      paddingLeft: 10,
      borderWidth: '1px',
      borderColor: state?.isDisabled ? '#00000026' : '#00000061',
      boxShadow: 'none'
    }
    if (state.isMulti) delete result.height
    return result
  },
}
export const Select: React.FC<any> = (props) => <ReactSelect styles={customStyles} {...props} />

export const SearchSelect: React.FC<SelectProps> = ({ className, placeholder, defaultValue, items, onSelect }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [selected, setSelected] = useState<SelectItem | undefined>(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (defaultValue && selected !== defaultValue) setSelected(defaultValue)
  }, [defaultValue])

  const close = () => {
    isOpen && setIsOpen(false);
  };

  useOnClickOutside(ref, close);

  const onSelectChange = (item: SelectItem) => {
    setSelected(item);
    onSelect && onSelect(item);
    close();
  };

  return (
    <div ref={ref} className={clsx(className, styles.root)}>
      <div className={styles.title} onClick={setIsOpen.bind(null, !isOpen)}>
        {selected?.name || placeholder}
        <Icon className={clsx(styles.icon, { [styles['is-open']]: isOpen })} name="arrow-down" />
      </div>
      {isOpen && (
        <ul className={styles.list}>
          {items.map(item => (
            <li key={item.name} onClick={onSelectChange.bind(null, item)} className={selected?.name == item.name ? 'active' : ''}>
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};